import React, { FC, useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  ImageList,
  ImageListItem,
  Avatar,
  ListItemText,
  Chip,
} from '@mui/material'
import { FaBitcoin, FaSortDown } from 'react-icons/fa6'
import { ROUTES } from '@utils/routes'
import useBalances from '@plug-core/hooks/useBalances'
import NFTDisplayer from '@components/NftDisplayer'
import { useNavigate } from 'react-router-dom'
import { Chain, NFT } from '@plug-core/interfaces/common'
import EmptyList from '@components/EmptyList'

interface Props {
  onNftClick?: (nft: NFT) => void
  fromSend?: boolean
  nftChain?: Chain
}

export const NftList: FC<Props> = ({ onNftClick, fromSend, nftChain }) => {
  const { walletNfts, nftsLoading } = useBalances()
  const [expanded, setExpanded] = useState('')
  const navigate = useNavigate()

  const renderNftItems = (item: NFT) => {
    return (
      <ImageListItem
        onClick={() =>
          onNftClick
            ? onNftClick(item)
            : navigate(
                ROUTES.NFT_DETAILS(
                  item.collection,
                  item.standard == 'ordinal' ? item.number.toString() : item.index.toString()
                ),
                {
                  state: { item },
                }
              )
        }
        sx={{ cursor: 'pointer' }}
        key={item.id}
      >
        {item && <NFTDisplayer nft={item} />}
      </ImageListItem>
    )
  }

  const renderAccordionItems = () => {
    let collections = walletNfts
    if (nftChain) {
      collections = collections.filter((collection) => collection.chain === nftChain)
    }

    return collections.map((entry) => (
      <Accordion
        expanded={expanded === entry.canisterId}
        onChange={() => setExpanded((prev) => (prev === entry.canisterId ? '' : entry.canisterId))}
        sx={{
          borderRadius: 1,
          border: 'none',
          '::before': { display: 'none' },
        }}
        key={entry.canisterId}
      >
        <AccordionSummary expandIcon={<FaSortDown style={{ marginTop: '-8px' }} color="white" />}>
          <Avatar sx={{ width: 24, height: 24, marginRight: 2 }} src={entry.icon} />
          <Stack
            direction="row"
            flexGrow={1}
            pr={1}
            alignItems="center"
            justifyContent="space-between"
          >
            <ListItemText primary={entry.name} />
            {entry.chain == Chain.BTC ? (
              <FaBitcoin size={24} color="#f7931a" />
            ) : (
              <Chip size="small" variant="outlined" label={entry.nfts.length} />
            )}
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <ImageList gap={16} cols={2}>
            {entry.nfts.map((nft) => renderNftItems(nft))}
          </ImageList>
        </AccordionDetails>
      </Accordion>
    ))
  }

  if (!nftsLoading && !fromSend && walletNfts.length === 0)
    return <EmptyList title="No collectibles available" description="Your NFTs will appear here" />

  return (
    <Stack flex={1} spacing={1}>
      {renderAccordionItems()}
    </Stack>
  )
}
